import { useState, useEffect } from 'react'
import { apiConfig } from '../config/api'

export interface SpotlightPack {
  id: string
  name: string
  impressions: number
  price_cents: number
  currency: string
  active: boolean
  description?: string
  recommended_duration_days?: number
}

export function useSpotlightPacks() {
  const [packs, setPacks] = useState<SpotlightPack[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchPacks = async () => {
      try {
        setIsLoading(true)
        setError(null)
        
        const token = localStorage.getItem('firebase_id_token')
        if (!token) {
          throw new Error('Authentication required')
        }

        const response = await fetch(`${apiConfig.baseURL}/api/v1/spotlight/packs`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({ detail: 'Failed to fetch packs' }))
          throw new Error(errorData.detail || `HTTP ${response.status}`)
        }

        const data = await response.json()
        setPacks(data.filter((pack: SpotlightPack) => pack.active))
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'Failed to load packs'
        setError(errorMessage)
        console.error('Failed to fetch packs:', err)
      } finally {
        setIsLoading(false)
      }
    }

    fetchPacks()
  }, [])

  return { packs, isLoading, error }
}



